export default __webpack_public_path__ + "static/media/254.8167e11b.jpg";